import { FC } from "react";
import { useSearchParams } from "react-router-dom";
import useI18n from "../../../../hooks/useTranslations";
import Tabs, { Tab } from "../../../ui/Tabs";
import Absorbers from "./absorbers/Absorbers";
import CurveIntermediates from "./curveIntermediates/CurveIntermediates";
import Membranes from "./membranes/Membranes";
import Normatives from "./normatives/Normatives";
import RoofCategories from "./roofCategories/RoofCategories";
import RoofMaterials from "./roofMaterials/RoofMarterials";
import RoofSubstructures from "./roofSubstructures/RoofSubstructures";
import SheetMaterials from "./sheetMaterials/SheetMaterials";
import SteelVersions from "./steelVersions/SteelVersions";
import SupportExtensions from "./supportExtensions/SupportExtensions";
import SupportExtras from "./supportExtras/SupportExtras";
import Supports from "./supports/Supports";
import PatrolSystems from "./systems/Systems";
import SystemTypes from "./systemTypes/SystemTypes";
import Terminals from "./terminals/Terminals";
import Texts from "./texts/Texts";

const PatrolSettings: FC = () => {
  const i18n = useI18n();
  const [searchParams] = useSearchParams();
  const selectedIndex = Number(searchParams.get("tab")) || 0;

  const tabs: Tab[] = [
    { title: i18n.translation.systems.plural },
    { title: i18n.translation.normatives.plural },
    { title: i18n.translation.common.roofs, hasSubTabs: true },
    { title: i18n.translation.common.supports, hasSubTabs: true },
    { title: i18n.translation.systemTypes.plural },
    { title: i18n.translation.absorbers.plural },
    { title: i18n.translation.patrolCurveIntermediates.plural },
    { title: i18n.translation.terminals.plural },
    { title: i18n.translation.texts.plural },
  ];

  return (
    <Tabs
      urlParameter="tab"
      tabs={tabs}
      contents={[
        <PatrolSystems active={selectedIndex === 0} />,
        <Normatives active={selectedIndex === 1} />,
        <RoofSettings active={selectedIndex === 2} />,
        <SupportSettings active={selectedIndex === 3} />,
        <SystemTypes active={selectedIndex === 4} />,
        <Absorbers active={selectedIndex === 5} />,
        <CurveIntermediates active={selectedIndex === 6} />,
        <Terminals active={selectedIndex === 7} />,
        <Texts active={selectedIndex === 8} />,
      ]}
    />
  );
};

export default PatrolSettings;

type SubTabsProps = {
  active?: boolean;
};

const RoofSettings: FC<SubTabsProps> = ({ active }) => {
  const i18n = useI18n();
  const [searchParams] = useSearchParams();
  const subSelectedIndex = Number(searchParams.get("r_t")) || 0;

  const tabs: Tab[] = [
    { title: i18n.translation.common.categories },
    { title: i18n.translation.materials.plural },
    { title: i18n.translation.common.substructures },
    { title: i18n.translation.sheetMaterials.plural },
    { title: i18n.translation.membranes.plural },
  ];
  return (
    <Tabs.SubTab>
      <Tabs
        tabs={tabs}
        urlParameter="r_t"
        contents={[
          <RoofCategories active={(active ?? true) && subSelectedIndex === 0} />,
          <RoofMaterials active={(active ?? true) && subSelectedIndex === 1} />,
          <RoofSubstructures active={(active ?? true) && subSelectedIndex === 2} />,
          <SheetMaterials active={(active ?? true) && subSelectedIndex === 3} />,
          <Membranes active={(active ?? true) && subSelectedIndex === 4} />,
        ]}
      />
    </Tabs.SubTab>
  );
};

const SupportSettings: FC<SubTabsProps> = ({ active }) => {
  const i18n = useI18n();
  const [searchParams] = useSearchParams();
  const subSelectedIndex = Number(searchParams.get("s_t")) || 0;

  const tabs: Tab[] = [
    { title: i18n.translation.steelVersions.plural },
    { title: i18n.translation.items.plural },
    { title: i18n.translation.common.extensions },
    { title: i18n.translation.common.extras },
  ];

  return (
    <Tabs.SubTab>
      <Tabs
        tabs={tabs}
        urlParameter="s_t"
        contents={[
          <SteelVersions active={(active ?? true) && subSelectedIndex === 0} />,
          <Supports active={(active ?? true) && subSelectedIndex === 1} />,
          <SupportExtensions active={(active ?? true) && subSelectedIndex === 2} />,
          <SupportExtras active={(active ?? true) && subSelectedIndex === 3} />,
        ]}
      />
    </Tabs.SubTab>
  );
};
